import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { getAccountWorkTypesAsync, resetSelectedRecordObjectInState, checkedAllState, unCheckedAllState, DeleteSelectedAccountWorkTypeAsync,updatePagination,updateSorting } from "./worktypeSlice";
import WorkTypeItem from "./WorkTypeItem";
import WorkTypeForm from "./WorkTypeForm";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const WorkType = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { worktypeList, isReload,isLoading,sortOrder, sortColumn, search, pageNo, pageSize  } = useAppSelector((state) => state.worktype);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (isReload) {

            dispatch(getAccountWorkTypesAsync());
        }
    }, [isReload])
    useEffect(() => {

        dispatch(getAccountWorkTypesAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());        
        setIsModalOpen(true);
    }

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData: any = getFilteredList(worktypeList, searchTerm);
    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = worktypeList.length;
    // const recordsFiltered = filteredData.length;

    const filteredData: any = getFilteredList(worktypeList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = worktypeList.length;
    const recordsFiltered = filteredData.length;

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountWorkTypeAsync(worktypeList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Work Type Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            // ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
           {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">
                        {/* {t('Work Type')} */}
                        {getValueFromResource('Work Type', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-workType"
                            data-tooltip-content={getValueFromResource('Configure the work categories available for timesheet entries, such as Standard Time, Overtime, Travel, Training, or other organization-specific work types. You can also define work type codes and display order.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && worktypeList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        } */}
 
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}

                        {(IsAdd || (IsDelete && worktypeList.some((item: any) => item.isSelected === 1))) && (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        )}


                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: worktypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Work Type')} */}
                                {getValueFromResource('Add Work Type',dispatch, t)}
                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: worktypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{worktypeList.filter((item: any) => item.isSelected === 1).length}</span> 
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: worktypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1">
                                <thead>
                                    <tr className="thHeading align-middle">
                                    <th style={{ width: '23%' }}>
                                        {/* {t('Active / Inactive')} */}
                                        {getValueFromResource('Active / Inactive',dispatch, t)}
                                         {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{ width: '23%' }}>
                                            {/* {t('Sort Order')}  */}
                                            {getValueFromResource('Sort Order',dispatch, t)}
                                            {sortColumn === 'SortOrder' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SortOrder") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SortOrder") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SortOrder") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SortOrder") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th style={{ width: '23%' }}>
                                            {/* {t('Work Type Code')} */}
                                            {getValueFromResource('Work Type Code',dispatch, t)}
                                        {sortColumn === 'AccountWorkTypeCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkTypeCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkTypeCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkTypeCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkTypeCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                        </th>
                                        <th style={{ width: '23%' }}>
                                            {/* {t('Work Type')} */}
                                            {getValueFromResource('Work Type',dispatch, t)}
                                        {sortColumn === 'AccountWorkType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                        </th>
                                        {/* {IsEdit &&
                                            <th className='w-25'>{t('Active / Inactive')}</th>
                                        } */}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 && currentItems.map((item:any, i :any) => {
                                        return <WorkTypeItem worktypeDetail={item} key={i} modelRef={modelRef} IsEdit={IsEdit} IsDelete={IsDelete} t={t} onopenModal={openModal} />
                                    })}
                                </tbody>
                            </table>
                                {currentItems.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
                    </div>
                </div>
            </div>
            {isModalOpen &&
                <WorkTypeForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
            <ReactTooltip
                id="tooltip-workType"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

export default WorkType;